import {
  ResendPatientPortalLoginCode,
  ResendPatientPortalLoginCodeVariables,
} from 'types/graphql'

import { TypedDocumentNode, useMutation } from '@cedarjs/web'
import { toast } from '@cedarjs/web/toast'

import { usePatientPortalAuth } from 'src/auth'
import { PortalOtpForm } from 'src/components/PortalOtpForm/PortalOtpForm'
import {
  PORTAL_AUTH_REQUEST_FAILED_MESSAGE,
  catchAuthRequestFailure,
} from 'src/lib/authRequestFailure'
import { usePatientPortalContext } from 'src/providers/context/PatientPortalContext/PatientPortalContext'

const REQUEST_CODE: TypedDocumentNode<
  ResendPatientPortalLoginCode,
  ResendPatientPortalLoginCodeVariables
> = gql`
  mutation ResendPatientPortalLoginCode(
    $input: RequestPatientPortalLoginCodeInput!
  ) {
    requestPatientPortalLoginCode(input: $input) {
      ok
    }
  }
`

export const PatientPortalLoginCodeStep = ({
  mobileNumber,
}: {
  mobileNumber: string
}) => {
  const { tenant } = usePatientPortalContext()!
  const tenantId = tenant!.id

  const { logIn, loading, reauthenticate } = usePatientPortalAuth()

  const [requestLoginCode, { loading: isRequestingCode }] = useMutation<
    ResendPatientPortalLoginCode,
    ResendPatientPortalLoginCodeVariables
  >(REQUEST_CODE)

  const resendCode = async () => {
    await requestLoginCode({
      variables: {
        input: {
          tenantId,
          mobileNumber,
        },
      },
      fetchPolicy: 'no-cache',
    })
  }
  return (
    <PortalOtpForm
      mobileNumber={mobileNumber}
      tenantId={tenantId}
      tenantPhoneNumber={tenant!.primaryPhoneNumber}
      logoUrl={tenant!.logoUrl ?? null}
      resendCode={resendCode}
      resendLoading={isRequestingCode}
      onSubmit={async ({ code }) => {
        const result = await catchAuthRequestFailure({
          request: logIn({
            username: [mobileNumber, tenantId].join(':'),
            password: code,
          }),
          source: 'portalLogin',
        })

        if (!result) {
          // A thrown logIn leaves Cedar's auth `loading` (this button's spinner) on.
          void reauthenticate()
          toast.error(PORTAL_AUTH_REQUEST_FAILED_MESSAGE)
        } else if (result.error) {
          toast.error(
            'Code is incorrect or has expired. Please try again or request a new code.'
          )
        }
      }}
      submitButton={{
        text: 'Log in',
        loading,
      }}
    />
  )
}
